import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import Vue2Filters from 'vue2-filters'
import Vue2Moment from 'vue-moment'

// CONTAINERS
import MarketFull from '@/containers/MarketFull'

// VIEWS
import Dashboard from '@/views/dashboard/Dashboard'
import OrderHistory from '@/views/orders/OrderHistory'
import Inventory from '@/views/inventory/Inventory'
import Pricing from '@/views/pricing/Pricing'
import Users from '@/views/users/Users'
import Setting from '@/views/setting/Setting'

// PAGES
import Login from '@/views/login/Login'

// PAGES ResetPassword
import ResetPassword from '@/views/resetPassword/ResetPassword'

// COMPONENTS
import SpotPrices from './components/SpotPrices.vue'
import InventoryList from './components/InventoryList.vue'

// TOASTED
import Toasted from 'vue-toasted'

Vue.component('spot-prices', SpotPrices)
Vue.component('inventory-list', InventoryList)

// MIDDLEWARE
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(Vue2Filters)
Vue.use(Vue2Moment)
Vue.use(BootstrapVue)
Vue.use(Toasted)

// ROUTING
const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Metal Market',
      component: MarketFull,
      redirect: '/dashboard',
      children: [
        {
          path: '/dashboard',
          meta: {
            auth: ['ADMIN', 'CUST']
          },
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/orders',
          meta: {
            auth: ['ADMIN', 'CUST']
          },
          name: 'OrderHistory',
          component: OrderHistory
        },
        {
          path: '/inventory',
          meta: {
            auth: ['ADMIN']
          },
          name: 'Inventory',
          component: Inventory
        },
        {
          path: '/pricing',
          meta: {
            auth: ['ADMIN']
          },
          name: 'Pricing',
          component: Pricing
        },
        {
          path: '/users',
          meta: {
            auth: ['ADMIN']
          },
          name: 'Users',
          component: Users
        },
        {
          path: '/setting',
          meta: {
            auth: ['ADMIN']
          },
          name: 'Setting',
          component: Setting
        }
      ]
    },
    {
      path: '/resetPassword',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: { auth: false }
    },
    // {
    //   base: '/resetPassword',
    //   routes: [
    //     {
    //       path: '/:id',
    //       name: 'ResetPassword',
    //       component: ResetPassword
    //     }]
    // },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { auth: false }
    },
    {
      path: '/403',
      name: 'Unauthorized',
      redirect: '/login'
    }
    // {
    //   path: '/:id',
    //   name: 'ResetPassword',
    //   component: ResetPassword
    // }
  ]
})

Vue.router = router

// AUTH
Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js')
})

// RESOURCE — in dev, API is proxied by webpack-dev-server (same origin)
if (process.env.NODE_ENV === 'development') {
  Vue.http.options.root = ''
}
if (process.env.NODE_ENV === 'production') {
  Vue.http.options.root = 'https://metalmarket.place'
}
if (process.env.NODE_ENV === 'beta') {
  Vue.http.options.root = 'http://test.metalmarket.place'
}
Vue.http.options.emulateJSON = true
Vue.http.options.credentials = true

// EVENT BUS
export const EventBus = new Vue()

Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/metalMarket.js